"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccessControlListController = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const access_control_list_service_1 = require("./access-control-list.service");
const response_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/response.utils");
const access_control_list_swagger_1 = require("./access-control-list.swagger");
const update_role_acl_dto_1 = require("./dto/update-role-acl.dto");
let AccessControlListController = class AccessControlListController {
    constructor(accessControlListService) {
        this.accessControlListService = accessControlListService;
    }
    async getAclMetadata(roleId, res) {
        try {
            if (roleId) {
                const data = await this.accessControlListService.getRoleAcl(+roleId);
                return res
                    .status(common_1.HttpStatus.OK)
                    .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, 'Role ACL retrieved successfully', data));
            }
            const data = await this.accessControlListService.getAclMetadata();
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, 'ACL metadata retrieved successfully', data));
        }
        catch (error) {
            return res
                .status(common_1.HttpStatus.INTERNAL_SERVER_ERROR)
                .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, error instanceof Error ? error.message : 'Failed to retrieve ACL data'));
        }
    }
    async updateRoleAcl(roleId, body, res) {
        try {
            await this.accessControlListService.updateRoleAcl(+roleId, body.aclIds);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, 'Role ACL updated successfully'));
        }
        catch (error) {
            return res
                .status(common_1.HttpStatus.INTERNAL_SERVER_ERROR)
                .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, error instanceof Error ? error.message : 'Failed to update role ACL'));
        }
    }
    /**
     * Retrieves the permissions for a specific user based on their roles and access control mappings.
     */
    async getUserPermissionsx(categoryKey, req, res) {
        try {
            const userId = parseInt(req?.headers?.userid);
            const permissions = await this.accessControlListService.getUserPermissions(userId, categoryKey);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, "Permissions retrieved successfully", permissions));
        }
        catch (error) {
            return res
                .status(common_1.HttpStatus.INTERNAL_SERVER_ERROR)
                .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, error instanceof Error
                ? error.message
                : "An unexpected error occurred while retrieving permissions"));
        }
    }
};
exports.AccessControlListController = AccessControlListController;
tslib_1.__decorate([
    (0, common_1.Get)(),
    tslib_1.__param(0, (0, common_1.Query)('role')),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [String, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], AccessControlListController.prototype, "getAclMetadata", null);
tslib_1.__decorate([
    (0, common_1.Put)('role/:roleId'),
    tslib_1.__param(0, (0, common_1.Param)('roleId')),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__param(2, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [String, typeof (_b = typeof update_role_acl_dto_1.UpdateRoleAclDto !== "undefined" && update_role_acl_dto_1.UpdateRoleAclDto) === "function" ? _b : Object, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], AccessControlListController.prototype, "updateRoleAcl", null);
tslib_1.__decorate([
    (0, common_1.Get)("permissions"),
    (0, access_control_list_swagger_1.getUserPermissionsSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Query)("categoryKey")),
    tslib_1.__param(1, (0, common_1.Req)()),
    tslib_1.__param(2, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [String, typeof (_c = typeof Request !== "undefined" && Request) === "function" ? _c : Object, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], AccessControlListController.prototype, "getUserPermissionsx", null);
exports.AccessControlListController = AccessControlListController = tslib_1.__decorate([
    (0, common_1.Controller)("access-control-list"),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof access_control_list_service_1.AccessControlListService !== "undefined" && access_control_list_service_1.AccessControlListService) === "function" ? _a : Object])
], AccessControlListController);
